import type { FormEvent } from "react";

type KioskFirstTimePanelProps = {
  name: string;
  onNameChange: (value: string) => void;
  mobile: string;
  onMobileChange: (value: string) => void;
  email: string;
  onEmailChange: (value: string) => void;
  location: string;
  onLocationChange: (value: string) => void;
  busy: boolean;
  disabled: boolean;
  error: string | null;
  onSubmit: () => void;
};

export function KioskFirstTimePanel({
  name,
  onNameChange,
  mobile,
  onMobileChange,
  email,
  onEmailChange,
  location,
  onLocationChange,
  busy,
  disabled,
  error,
  onSubmit,
}: KioskFirstTimePanelProps) {
  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!name.trim() || busy || disabled) return;
    onSubmit();
  }

  return (
    <form className="kiosk-panel kiosk-first-time" onSubmit={handleSubmit}>
      <label className="kiosk-field">
        <span>Full name *</span>
        <input
          className="kiosk-input"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          required
          autoComplete="name"
          disabled={busy || disabled}
          autoFocus
        />
      </label>
      <label className="kiosk-field">
        <span>Mobile</span>
        <input
          className="kiosk-input"
          type="tel"
          inputMode="tel"
          value={mobile}
          onChange={(e) => onMobileChange(e.target.value)}
          autoComplete="tel"
          disabled={busy || disabled}
        />
      </label>
      <label className="kiosk-field">
        <span>Email</span>
        <input
          className="kiosk-input"
          type="email"
          inputMode="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          autoComplete="email"
          disabled={busy || disabled}
        />
      </label>
      <label className="kiosk-field">
        <span>Location</span>
        <input
          className="kiosk-input"
          value={location}
          onChange={(e) => onLocationChange(e.target.value)}
          autoComplete="address-level2"
          placeholder="Kampala, Entebbe…"
          disabled={busy || disabled}
        />
      </label>

      {error && <div className="form-error kiosk-message">{error}</div>}

      <button
        type="submit"
        className="btn btn-primary kiosk-btn kiosk-btn-primary"
        disabled={busy || disabled || !name.trim()}
      >
        {busy ? "Registering…" : "Register & check in"}
      </button>
    </form>
  );
}
